import { observer } from 'mobx-react-lite';
import { Spinner } from "react-bootstrap";
import { VoucherStore } from "../../stores/VoucherStore";

type Props = {
    voucherStore: VoucherStore
}

const VoucherStatus: React.FC<Props> = observer(({ voucherStore }: Props) => {
    return (   
      <div className='row voucher-summary'>
        <div className='col-sm-4'>
          <div className='voucher-stat'>VOUCHER ACQUISTATI 
            {voucherStore.voucherStatus.purchased >= 0 
            ? (<strong>{voucherStore.voucherStatus.purchased}</strong>) 
            : (<Spinner animation="grow" size="sm" />)}
          </div>
        </div>
        <div className='col-sm-4'>
          <div className='voucher-stat'>VOUCHER UTILIZZATI
            {voucherStore.voucherStatus.used >= 0 
            ? (<strong>{voucherStore.voucherStatus.used}</strong>) 
            : (<Spinner animation="grow" size="sm" />)}
          </div>
        </div>
        <div className='col-sm-4'>
            <div className='voucher-stat'>VOUCHER RESIDUI
            {voucherStore.voucherStatus.remained >= 0 
            ? (<strong>{voucherStore.voucherStatus.remained}</strong>) 
            : (<Spinner animation="grow" size="sm" />)}
            </div>
        </div>
      </div>
    );
})

export default VoucherStatus;